/**
 * @file 分账号业务用量页面
 */
<template>
  <div class="p-sub-account-business-usage">
    <div class="p-business-usage-search">
      <plv-condition-filter v-model="conditionFilter" @search="handleSearch">
        <plv-condition-filter-item label="账期">
          <el-date-picker
            v-model="conditionFilter.dateRange"
            value-format="timestamp"
            size="small"
            type="monthrange"
            range-separator="至"
            start-placeholder="开始月份"
            end-placeholder="结束月份"
            :picker-options="{
              disabledDate: filterDisabledMonth,
              onPick: onMonthPicker
            }"
            :clearable="false"
            :default-time="['00:00:00', '23:59:59']"
          />
        </plv-condition-filter-item>
        <plv-condition-filter-item
          prop="productItem"
          label="产品分类"
        >
          <plv-cascader
            v-model="conditionFilter.billItem"
            :options="productOptions"
            placeholder="请选择"
          />
        </plv-condition-filter-item>

        <!-- <plv-condition-filter-item
          prop="billItem"
          label="计费项"
          type="select"
          :select-options="billItems"
        /> -->

        <plv-condition-filter-item type="search" />
      </plv-condition-filter>
    </div>
    <div class="p-business-usage-export">
      <plv-button @click="handleExportFile">导出数据</plv-button>
    </div>
    <div class="p-business-usage-table">
      <plv-table v-loading="loading" :data-source.sync="dataSource" @pageDataChange="handlePageChange">
        <plv-table-column
          v-for="item of tableItems"
          :key="item.prop"
          :title="item.title"
          :prop="item.prop"
        />
      </plv-table>
    </div>
  </div>
</template>

<script>
import billMixin from '@/mixins/bill';
import { exportFile } from '@/utils/utils';
export default {
  mixins: [billMixin],
  data() {
    return {
      loading: false,
      tableItems: [
        { title: '账期', prop: 'accountPeriod' },
        { title: '分账号邮箱', prop: 'email' },
        { title: '产品', prop: 'production' },
        { title: '计费项', prop: 'category' },
        { title: '用量', prop: 'itemConsumed' },
        { title: '用量单位', prop: 'itemConsumedUnit' },
        { title: '结算日期', prop: 'statAt' }
      ]
    };
  },

  created() {
    this.getBusinessUsage();
  },
  methods: {
    async getBusinessUsage() {
      const { id } = this.$route.params;
      const params = this.getSearchParams(id);
      try {
        this.loading = true;
        const res = await this.$store.dispatch('account/getAccountDosage', params);
        this.dataSource.contents = res.contents;
        this.dataSource.pageNumber = res.pageNumber;
        this.dataSource.pageSize = res.pageSize;
        this.dataSource.totalItems = res.totalItems;
      } finally {
        this.loading = false;
      }
    },
    handleSearch() {
      this.getBusinessUsage();
    },
    handlePageChange() {
      this.getBusinessUsage();
    },
    async handleExportFile() {
      const { id } = this.$route.params;
      const params = this.getSearchParams(id);
      const res = await this.$store.dispatch('account/exportDosageFile', params);
      res && exportFile(res);
    },
  }
};
</script>

<style lang="scss">
.p-sub-account-business-usage {
  padding: 0 18px;
  .p-business-usage-export {
    margin-bottom: 20px;
  }
}
</style>
